import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ColumnsTabContentComponent } from './upload-modal/columns-tab-content/columns-tab-content.component';
import { WorksheetTabsContentComponent } from './upload-modal/worksheet-tabs-content/worksheet-tabs-content.component';
import { SummaryTabContentComponent } from './upload-modal/summary-tab-content/summary-tab-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { CommonModule } from '@angular/common';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { HttpClientModule } from '@angular/common/http';
import { DragulaModule } from 'ng2-dragula';
import { UtilSharedModule } from '../util-shared/util-shared.module';
import { LayoutSharedModule } from '../layout-shared/layout-shared.module';
import { FileTypeIconPipe, TruncatePipe } from '@aptitude/angular-pipes';

@NgModule({
  declarations: [
    UploadModalComponent,
    ColumnsTabContentComponent,
    WorksheetTabsContentComponent,
    SummaryTabContentComponent,
  ],
  providers: [FileTypeIconPipe, TruncatePipe],
  imports: [
    HttpClientModule,
    CommonModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    DragulaModule,
    LayoutSharedModule,
    UtilSharedModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UploadModule {}
